import { BaseEditModel } from "model/BaseEditModel";
import Deposito from "./Deposito";
import ItemTransferencia from "./ItemTransferencia";
import Transacao from "./Transacao";


export default class TransferenciaEstoque {
    transacaoEntrada: Transacao | null;
    transacaoSaida: Transacao| null;
    depositoOrigem: Deposito;
    depositoDestino: Deposito;
    itens: ItemTransferencia[];

    constructor( 
        transacaoEntrada = null,
        transacaoSaida = null,
        depositoOrigem = new Deposito(),
        depositoDestino = new Deposito(),
        itens = []
    ) {
        this.transacaoEntrada = transacaoEntrada;
        this.transacaoSaida = transacaoSaida;
        this.depositoOrigem = depositoOrigem;
        this.depositoDestino = depositoDestino;
        this.itens = itens;
    }

}